import { RenderHtml } from '../../../utils';
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
export const InformativeComponent = (props) => {
    const informativeTitle = props.value.title;
    const informativeColor = props.value.color;
    return (React.createElement("div", { className: classNames('component', 'informative-component', props.direction), "data-component-type": 'informative' },
        React.createElement("div", { className: 'informative-content', "data-color": informativeColor },
            React.createElement("span", { className: 'informative-title' },
                React.createElement("strong", null, informativeTitle)),
            React.createElement(RenderHtml, { html: props.value.html, className: 'rendered-html' }))));
};
